import React from "react";
import { Button, Modal } from "react-blueprint-library";
import "../../../assets/stylesheets/EmploymentHistoryWarnModal.scss";
import NavigationButtons from "../../SharedComponents/NavigationButtons";

export default function EmploymentHistoryDeleteWarnModal(props) {
  return (
    <>
      <div>
        <div id="backModal"></div>

        <div>
          <Modal
            id="EmploymentHistoryWarn"
            show={props.isOpen}
            className="modal-md"
            title=""
          >
            {props.show_spinner === false && (
              <div>
                <div className="modal-body" id="top_delete_element">
                  <div className="container">
                    <div className="modal-header">
                      <h2>
                        <div>{props.message}</div>
                      </h2>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close modal dialog"
                        onClick={props.closeClick}
                      />
                    </div>
                    <NavigationButtons
                      onNext={props?.deleteClick}
                      onBack={props?.closeClick}
                      nextBtnText="Yes, Delete"
                      backBtnText="No, Nevermind"
                    ></NavigationButtons>
                  </div>
                </div>
              </div>
            )}
            {props.show_spinner && (
              <>
                <div
                  className="row"
                  style={{ marginTop: "15px", height: "150px" }}
                >
                  <div
                    id="emp_hist_delete_loading"
                    className="mm-dots-loading-xl"
                    style={{ marginLeft: "225px", marginTop: "50px" }}
                  />
                </div>
              </>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
}
